import { TemplateResult } from 'lit';
import { unsafeStatic, html } from 'lit/static-html.js';

import { sortByNumericProperty } from '../../common/utils/arraySort';
import type {
  SectorAttributionArgs,
  SectorAttributionItem,
} from './sector-attribution.model.js';
import { Constants } from './sector-attribution.constants.js';

export const generateHTML = (
  args: SectorAttributionArgs,
): TemplateResult => html`
  <${unsafeStatic(Constants.TAG_NAME)}
    data-component-object="${JSON.stringify(args?.componentObject)}"
  ></${unsafeStatic(Constants.TAG_NAME)}>
`;

/**
 * This is used to arrange the sector items in the order needed
 * for the chart data, with the total first, followed by the
 * sectors in order by total value added, descending.
 */
export function prepareItemsForChart(
  items: SectorAttributionItem[],
): SectorAttributionItem[] {
  return [
    ...items.filter((item) => item.isTotalForAllSectors),
    ...sortByNumericProperty(
      items.filter((item) => !item.isTotalForAllSectors),
      'totalValueAddedPercent',
      'desc',
    ),
  ];
}
